<template>
    <span class="tw-flex tw-flex-row tw-items-baseline tw-font-title tw-uppercase tw-font-semibold">
        <template v-if="!props.category?.icon">
            {{ $t(name) }}
        </template>
        <Logo24
            v-if="contains24"
            class="tw-ml-[0.2em] tw-size-[1em]" />
        <component
            :is="props.category.icon"
            v-if="props.category?.icon"
            class="tw-h-[0.85em] tw-w-auto" />
    </span>
</template>

<script setup lang="ts">
    import type { Category } from '@/configs/categories';

    const props = defineProps<{
        name?: string;
        category?: Category | null | undefined;
    }>();

    const contains24 = computed(() => {
        return props.name?.includes('24') || props.category?.title?.includes('24');
    });

    const name = computed(() => {
        return props.category?.title || props.name || 'App.title';
    });
</script>

<style scoped></style>
